import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  all: {
    id: 'Glxcvm',
    defaultMessage: 'All',
    description: 'Table button label for numeric input',
  },
});
